// CloudFormation templates as string arrays to avoid template literal / YAML quoting conflicts
// v3 — includes both Lambda roles (AssumeRole + AssessmentService) for MPA discovery

const ASSUME_ROLE_LAMBDA = 'cost-optimization-prod-or-AssumeRoleFunctionService-kFDFqxvkOsKV';
const ASSESSMENT_LAMBDA = 'cost-optimization-prod-ap-AssessmentServiceFunction-SinkLvxmXY1y';
const HONNE_ACCOUNT = '203637463660';
const EXTERNAL_ID = 'honne-cost-optimization-2024';

const COMMON_TRUST = [
  "      AssumeRolePolicyDocument:",
  "        Version: '2012-10-17'",
  "        Statement:",
  "          - Effect: Allow",
  "            Principal:",
  "              AWS:",
  `                - 'arn:aws:iam::${HONNE_ACCOUNT}:role/${ASSUME_ROLE_LAMBDA}'`,
  `                - 'arn:aws:iam::${HONNE_ACCOUNT}:role/${ASSESSMENT_LAMBDA}'`,
  "            Action: sts:AssumeRole",
  "            Condition:",
  "              StringEquals:",
  `                sts:ExternalId: '${EXTERNAL_ID}'`,
].join('\n');

const COMMON_PARAMS = [
  "Parameters:",
  "  HonneAccountId:",
  "    Type: String",
  `    Default: '${HONNE_ACCOUNT}'`,
  "    Description: ID de la cuenta AWS de Honne (no modificar)",
  "  ExternalId:",
  "    Type: String",
  `    Default: '${EXTERNAL_ID}'`,
  "    Description: External ID de seguridad (no modificar)",
].join('\n');

const COMMON_ROLE_PROPS = [
  "      RoleName: HonneAutomatedReportsRole",
  "      MaxSessionDuration: 3600",
  COMMON_TRUST,
  "      ManagedPolicyArns:",
  "        - arn:aws:iam::aws:policy/ReadOnlyAccess",
].join('\n');

// ── Management Account / cuenta individual ────────────────────────────────────
export const CLOUDFORMATION_TEMPLATE = [
  "AWSTemplateFormatVersion: '2010-09-09'",
  "Description: Rol IAM de solo lectura para Honne Automated Reports (MPA o cuenta individual)",
  "",
  COMMON_PARAMS,
  "",
  "Resources:",
  "  HonneAutomatedReportsRole:",
  "    Type: AWS::IAM::Role",
  "    Properties:",
  COMMON_ROLE_PROPS,
  "      Policies:",
  "        - PolicyName: SecurityReadAccess",
  "          PolicyDocument:",
  "            Version: '2012-10-17'",
  "            Statement:",
  "              - Effect: Allow",
  "                Action:",
  "                  - support:DescribeTrustedAdvisorChecks",
  "                  - support:DescribeTrustedAdvisorCheckResult",
  "                  - securityhub:GetFindings",
  "                  - securityhub:DescribeHub",
  "                  - organizations:ListAccounts",
  "                  - organizations:DescribeOrganization",
  "                Resource: '*'",
  "",
  "Outputs:",
  "  RoleArn:",
  "    Value: !GetAtt HonneAutomatedReportsRole.Arn",
  "    Description: Proporcione este ARN a su ejecutivo de Honne",
].join('\n');

// ── Cuentas miembro (StackSets) ───────────────────────────────────────────────
export const CLOUDFORMATION_TEMPLATE_MEMBER = [
  "AWSTemplateFormatVersion: '2010-09-09'",
  "Description: Rol IAM de solo lectura para Honne Automated Reports (cuenta miembro de organizacion)",
  "",
  COMMON_PARAMS,
  "",
  "Resources:",
  "  HonneAutomatedReportsRole:",
  "    Type: AWS::IAM::Role",
  "    Properties:",
  COMMON_ROLE_PROPS,
  "      Policies:",
  "        - PolicyName: SecurityReadAccess",
  "          PolicyDocument:",
  "            Version: '2012-10-17'",
  "            Statement:",
  "              - Effect: Allow",
  "                Action:",
  "                  - support:DescribeTrustedAdvisorChecks",
  "                  - support:DescribeTrustedAdvisorCheckResult",
  "                  - securityhub:GetFindings",
  "                  - securityhub:DescribeHub",
  "                Resource: '*'",
  "",
  "Outputs:",
  "  RoleArn:",
  "    Value: !GetAtt HonneAutomatedReportsRole.Arn",
  "    Description: ARN del rol creado en esta cuenta miembro",
].join('\n');
